export function capitalize(str) {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export function camelToDash(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function truncateText(string, allowedLength) {
  return `${string.substring(0, allowedLength - 3)}...`;
}

/**
 * @param {string} content
 * @return {string}
 *
 * @link https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/
 */
export function stripTags(content) {
  return content
    .replace(/(<([^>]+)>)/ig, '');
}

/**
 * @param {string} dateString
 * @return {string}
 *
 * Returns date in format, which is required for was price ('D/M/YY')
 */
export function formatWasPriceDate(dateString) {
  let d = new Date(dateString);
  if (Number.isNaN(d.getDate())) {
    d = new Date(`${dateString.split('+')[0]}Z`);
  }
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear().toString().substr(2, 2)}`;
}

/**
 * @param {string} wasPriceDate
 * @return {string}
 *
 * Returns date in format, which is required for was price ('D/M/YY')
 */
export function wasPriceDateTrimYear(wasPriceDate) {
  return wasPriceDate
    .split('/')
    .map((datePart, i) => (i === 2 ? datePart.slice(2, 4) : datePart))
    .join('/');
}

/**
 * @param {React.ReactChild} node
 * @return {string}
 *
 * @description
 * Extracts the text content of any arbitrary component or children
 *
 * @example https://codesandbox.io/s/react-getnodetext-h21ss
 */
export const getNodeText = (node) => {
  if (['string', 'number'].includes(typeof node)) return node;
  if (node instanceof Array) return node.map(getNodeText).join('');
  if (typeof node === 'object' && node) return getNodeText(node.props.children);
};

/**
 * @param {string | React.ReactChild} label ideally the element's innerText
 * @return {string}
 *
 * @description
 * Returns a normalized string that can be used eg. in element's ID attribute for anchor-linkability
 *
 * @example https://codesandbox.io/s/react-getnodetext-h21ss
 */
export const slugify = (label = '') => getNodeText(label).toLowerCase()
  .replace(/[’']/g, '')
  .replace(/[^a-z0-9_]+/g, '-')
  .replace(/^-+|-+$/g, '');
